import api from "../_api";

const actions = {
    getProductDonation: ({ commit, dispatch }) => {
        return new Promise((resolve, reject) => {
            commit("PRODUCT_DONATION_LOADING");

            api.productDonation()
                .then(product => {
                    commit("PRODUCT_DONATION_SUCCESS");
                    resolve(product.data);
                })
                .catch(err => {
                    let errors = { error: "Techinal Issue, Please try again later" };
                    let errorMsg = errors.error;
                    if (err.response.status != 500) {
                        errors = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;
                    }

                    commit("PRODUCT_DONATION_ERROR", errors);
                    reject(errorMsg);
                });
        });
    },
    addDonation: ({ commit }, product) => {
        commit("ADD_DONATION", product);
        commit("UPDATE_DONATION_TOTAL");
    },
    removeDonation: ({ commit }, product) => {
        commit("REMOVE_DONATION", product);
        commit("UPDATE_DONATION_TOTAL");
    },
};

export default actions;
